import { Component, OnInit } from '@angular/core';

import { UploaderService } from '../../../services/uploader.service';
import { AuthService } from '../../../services/auth.service';

import { MatDialogRef } from '@angular/material';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-modal-add-avatar',
  templateUrl: './modal-add-avatar.component.html',
  styleUrls: ['./modal-add-avatar.component.scss']
})
export class ModalAddAvatarComponent implements OnInit {
  
  public fileData: File = null;
  public previewUrl:any = null;
  public progress: number = 0;
  public isUploading: boolean = false;  
  public uploadedFilePath: string = null;
  public avatarImg: string;

  constructor(
    private uploader: UploaderService,
    private dialogRef: MatDialogRef<ModalAddAvatarComponent>,
    private toastr: ToastrService,
    private authService: AuthService
  ) { }

  ngOnInit() {
    
    this.authService.getAvatar().subscribe(img => {
      this.avatarImg = img;
    });

    this.uploader.progressSource.subscribe(progress => {
      this.progress = progress;
    });
    
    this.previewUrl = this.avatarImg;
  }

  public fileProgress(fileInput: any) {
    this.fileData = <File>fileInput.target.files[0];
    this.preview();
  }
  
  public onUpload() {

    if (this.fileData) {
      this.progress = 0;
      this.isUploading = true;
  
      this.uploader.upload(this.fileData).subscribe(message => {
        this.fileData = null;
        this.isUploading = false;
        this.toastr.success(`Editado com sucesso`, null, {
          timeOut: 2000,
          positionClass: 'toast-bottom-center',
          progressAnimation: 'decreasing',
          closeButton: true
        });
      }, (error) => {
        this.isUploading = false;
      });
    }
    
  }

  public closeDialog() {
    this.dialogRef.close();
  }

  private preview() {    
    // Show preview 
    var mimeType = this.fileData.type;
    if (mimeType.match(/image\/*/) == null) {
      alert('Arquivo inválido');      
      this.fileData = null;
      return;
    }
 
    var reader = new FileReader();      
    reader.readAsDataURL(this.fileData); 
    reader.onload = (_event) => { 
      this.previewUrl = "";
      this.previewUrl = reader.result; 
    }
  }

}
